import { defineComponent as _defineComponent } from 'vue'
import { Address } from '@/models/Address';
import { computed } from 'vue';
import AddressIconBar from './AddressIconBar.vue';
import { stripHtml } from '@/helpers/tools';


export default /*#__PURE__*/_defineComponent({
  __name: 'list-item-title',
  props: {
    item: {
        type: Address,
        required: true,
    },
},
  setup(__props) {

const props = __props;



const title = computed(() => props.item.displayTitle || props.item.title);

return { __sfc: true,props, title, AddressIconBar, stripHtml }
}

})